import axios from "axios";

export function init() {
    // Find the corresponding Form
    const forms = document.querySelectorAll(".js-freeform");

    if (forms.length) {
        forms.forEach((form, idx, array) => {
            // Refresh CSRF and Hash
            axios
                .get(`/ajax/freeform?form=${form.dataset.handle}`, {
                    headers: { "X-Requested-With": "XMLHttpRequest" },
                })
                .then((response) => {
                    // Update the Form Hash
                    form.querySelector("input[name=formHash]").value =
                        response.data.hash;

                    // Update the Payload if encrypted payloads are enabled
                    form.querySelector("input[name=freeform_payload]").value =
                        response.data.payload;

                    // Update the JS Honeypot (ONLY when JS Enhancement setting is ON)
                    // var honeypot = response.data.honeypot;
                    // var honeypotInput = form.querySelector(
                    //     'input[name^="freeform_form_handle"]'
                    // );

                    // if (honeypotInput) {
                    // honeypotInput.setAttribute("id", honeypot.name);
                    // honeypotInput.setAttribute("name", honeypot.name);
                    // honeypotInput.value = honeypot.hash;
                    // }

                    // Update the CSRF input
                    var csrf = response.data.csrf;
                    form.querySelector(`input[name=${csrf.name}]`).value =
                        csrf.value;

                    // If this is the last loop, update ALL
                    // CSRF fields on the page with the same value
                    // if (idx === array.length - 1) {
                    //     // Locate and update the CSRF input
                    //     var csrf = response.data.csrf;
                    //     document
                    //         .querySelectorAll(`input[name=${csrf.name}]`)
                    //         .forEach((field) => {
                    //             field.value = csrf.value;
                    //         });
                    // }
                });

            // Validate email address on keyup
            let emailField = form.querySelector("input[name=email]");
            if (emailField) {
                emailField.addEventListener("blur", function () {
                    if (validateEmail(emailField.value.trim())) {
                        // Remove any errors
                        emailField.parentElement
                            .querySelector(".ff-errors")
                            ?.remove();
                    } else {
                        // Add error if doesn't already exist
                        if (
                            !emailField.parentElement.querySelector(
                                ".ff-errors"
                            )
                        ) {
                            const error = document.createElement("p");
                            error.classList.add("ff-errors");
                            error.innerText =
                                "Please enter a valid email address";
                            emailField.parentElement.appendChild(error);
                        }
                    }
                });
            }
        });
    }

    // Place success message at end of form
    document.addEventListener("freeform-render-success", function (event) {
        const options = event.freeform.options;
        const form = event.form,
            isDonateForm = form.classList.contains("js-form-donate");

        if (isDonateForm) {
            const frequency = form.querySelector('input[name="donationType"]');

            if (event.response.finished) {
                if (frequency && frequency.value === "monthly") {
                    // Stop the default success message rendering
                    event.preventDefault();

                    // Redirect to donation endpoint so we can redirect to GoCardless
                    window.location.href = `/donations/create?s=${event.response.submissionToken}`;
                }
            }
        } else {
            // Stop the default success message rendering
            event.preventDefault();

            // Create a custom banner <div>
            const banner = document.createElement("div");

            banner.classList.add(
                "mt-5",
                "p-4",
                "bg-white",
                "rounded-lg",
                "text-sbs-cyan-800",
                "text-lg",
                "font-medium"
            );
            banner.innerText = options.successBannerMessage;

            form.appendChild(banner);
        }
    });

    // Place Error Message at end of Form
    document.addEventListener("freeform-render-form-errors", function (event) {
        // Stop the default form error rendering
        event.preventDefault();

        const options = event.freeform.options,
            errors = event.errors,
            form = event.form,
            classNames = options.errorClassBanner, // Get the error banner css class names
            errorBlock = document.createElement("div"),
            paragraph = document.createElement("p"),
            isDonateForm = form.classList.contains("js-form-donate");

        errorBlock.classList.add(classNames);

        paragraph.appendChild(
            document.createTextNode(options.errorBannerMessage)
        );

        errorBlock.appendChild(paragraph);

        if (isDonateForm) {
            if (errors.length) {
                const errorsList = document.createElement("ul");

                for (
                    let messageIndex = 0;
                    messageIndex < errors.length;
                    messageIndex++
                ) {
                    const message = errors[messageIndex],
                        listItem = document.createElement("li");

                    listItem.appendChild(document.createTextNode(message));
                    errorsList.appendChild(listItem);
                }

                errorBlock.appendChild(errorsList);
            }
        }

        form.appendChild(errorBlock);
    });
}

function validateEmail(email) {
    // Regular expression pattern to validate email addresses
    // const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const pattern =
        /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

    // Check if the email matches the pattern
    if (pattern.test(email)) {
        return true; // Email is valid
    }

    return false; // Email is invalid
}
